import GeofencesTable from "./GeofencesTable"

export default  GeofencesTable;



// WEBPACK FOOTER //
// ./src/components/App/Geofence/GeofencesTable/index.js